import  React, {useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import { Accordion, AccordionDetails, AccordionSummary, Divider } from '@mui/material';
import { BackNavIcon, DownIcon } from '../../../../assets/common-svg/CommonSvg';
import ReactQuill from 'react-quill';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import InfiniteScroll from 'react-infinite-scroll-component';
import { listingByProcessId } from '../../../slices/help';
import NoDataCard from '../../../../components/no-data-card';

const DetailHelp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { processId } = location.state || {};

  const [localPage, setLocalPage] = useState(1);
  const [helpData, setHelpData] = useState([]);
  const [maxPages, setMaxPages] = useState(1);

    const fetchInitialData = async () => {
      try {
        const response = await dispatch(
          listingByProcessId({
            params: {
              id: processId,
              status: 1,
              page: 1,
              per_page: 10,
              search: "",
            },
            fromModal: true,
          })
        ).unwrap();
        setHelpData(response.data.data.items || []);
        setMaxPages(response.data.data.total_count || 1);
      } catch (err) {
        console.error("Failed to load initial data:", err);
      }
    };


  const handleBackNav = () => {
    navigate('/bmr/faq');
  };

  const handleLoadMore = async () => {
    if (localPage >= maxPages) return;
    const nextPage = localPage + 1;
    try {
      const response = await dispatch(
        listingByProcessId({
          params: {
            id: processId,
            status: -1,
            page: nextPage,
            per_page: 10,
            search: "",
          },
          fromModal: true,
        })
      ).unwrap();

      setHelpData((prev) => {
        return [...prev, ...response.data.data.items];
      });
      setLocalPage(nextPage);
    } catch (err) {
      console.error("Failed to load more:", err);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, [dispatch, processId]);

  return (
    <div className="!p-6">
      <button className="cursor-pointer mr-1 sm:mr-3 flex gap-2" onClick={handleBackNav}>
        <BackNavIcon /> Back
      </button>
      <div className=" mt-3 bg-white flex flex-col gap-4 rounded-2xl">
        <div className="flex justify-center p-0 pt-2">
          <Typography variant="h3" component="h2" className="text-center">
          Frequently Asked Questions
          </Typography>
        </div>
        <Divider />
        {helpData.length > 0 ?
          <div className='p-3'>
            <InfiniteScroll
              dataLength={helpData.length}
              next={handleLoadMore}
              hasMore={localPage < maxPages}
            >
              {helpData.map((item, index) => (
                <Accordion
                  key={item.id}
                  defaultExpanded={index == 0}
                  className="accordian-cards"
                  style={{
                    backgroundColor: '#F0F1F5',
                    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
                    borderRadius: '10px',
                    marginBottom: '10px',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<DownIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                    className="faq-title"
                  >
                    <Typography variant="h6">{item.title}</Typography>
                  </AccordionSummary >
                  <AccordionDetails className='p-0'>
                    <Divider />
                    <div className="hide-editable p-2">
                      <ReactQuill
                        theme="snow"
                        value={item.content}
                        readOnly
                        modules={{
                          toolbar: false,
                        }}
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </InfiniteScroll>
          </div>
          :
          <div className="mt-4">
            <NoDataCard />
          </div>}

      </div>
    </div>
  );
};

export default DetailHelp;